<script type="ts">
	import Avatar from '$Chat/Avatar.svelte';
	import type { AchordData } from 'src/app';
	

	export let online: AchordData.Profile[];
</script>

{#each online as profile}
	<div class="profile">
		<Avatar size="36px" name={profile.avatar} online={profile.online} />
		<div class="name">
			{profile.name}
		</div>
	</div>
{/each}

<style lang="scss">
	.profile {
		display: flex;
		align-items: center;
		cursor: pointer;
		border-radius: $border_radius;
		gap: 11px;
		padding: 7px 18px;
		font-weight: 500;
		letter-spacing: 0.2px;
		color: var(--demo-text-low);

		&:hover {
			background-color: var(--demo-overlay);
			color: var(--demo-text);
		}
	}
</style>
